// 引入api请求方法
import { getCollectionList, findChannelInfoByCorp } from '@/api/captain';
import { getProjectListByBid } from '@/api/project';
import { getRouteListByBid } from '@/api/routeInfo';
import {
  getWaybillSettlementList,
  getWaybillSettlementStatistics,
  waybillSettlementExportUrl,
} from '@/api/freight';
import { getHMSCountDownText } from '@/utils/date';
import { payTypeList, whethers, settlementTypes, waybillPayStatus } from '@/utils/selectCom';

const wojiaVersions = [
  { label: '我家3.0运单', value: 'v1' },
  { label: '我家4.0运单', value: 'v2' },
];
const storeModuleName = 'freightModule';
const state = {
  // 筛选项-
  parameters: [
    {
      style: 'select',
      param: 'businessId',
      isFixed: true,
      value: '',
      valueType: 'string',
      state: 'companyList',
      label: '企业',
      placeholder: '请选择',
      noMatchText: '无匹配企业',
      clearable: false,
      filterable: false,
      path: `${storeModuleName}/getCompanyList`,
    },
    {
      style: 'input-multiple',
      param: 'waybillNos',
      value: '',
      valueType: 'string',
      label: '运单号',
      multiple: true,
      placeholder: '请输入',
      append: '多运单',
      multipleLabel: '运单号',
      multiplePlaceholder:
        '最多可填写50个运单号，需输入完整运单号，运单号中间不能有空格，运单号不换行时请用英文逗号隔开，换行时请每行1个运单号。',
      clearable: true,
    },
    {
      style: 'input-multiple',
      param: 'settlementIds',
      value: '',
      valueType: 'string',
      label: '支付单号',
      multiple: true,
      placeholder: '请输入',
      append: '多支付单',
      multipleLabel: '支付单号',
      multiplePlaceholder:
        '最多可填写50个支付单号，需输入完整支付单号，支付单号中间不能有空格，支付单号不换行时请用英文逗号隔开，换行时请每行1个支付单号。',
      clearable: true,
    },
    {
      style: 'input-multiple',
      param: 'driverMobiles',
      value: '',
      valueType: 'string',
      label: '司机',
      multiple: true,
      placeholder: '姓名/手机号',
      append: '多司机',
      multipleLabel: '姓名/手机号',
      multiplePlaceholder:
        '最多可填写50个姓名/手机号，需输入完整姓名/手机号，姓名/手机号中间不能有空格，姓名/手机号不换行时请用英文逗号隔开，换行时请每行1个姓名/手机号。',
      clearable: true,
    },
    {
      style: 'input-multiple',
      param: 'vehicleNos',
      value: '',
      valueType: 'string',
      label: '车牌号',
      multiple: true,
      placeholder: '请输入',
      append: '多车牌号',
      multipleLabel: '车牌号',
      multiplePlaceholder:
        '最多可填写50个车牌号，需输入完整车牌号，车牌号中间不能有空格，车牌号不换行时请用英文逗号隔开，换行时请每行1个车牌号。',
      clearable: true,
    },
    {
      style: 'autocomplete',
      param: 'orderName',
      value: '',
      valueType: 'string',
      label: '线路名称',
      placeholder: '请输入',
      noMatchText: '无匹配请输入',
      clearable: true,
      filterable: false,
      path: `${storeModuleName}/getRouteList`,
    },
    {
      style: 'date-picker',
      param: 'insertTime',
      value: [],
      valueType: 'date',
      label: '申请时间',
      placeholder: '请选择',
      type: 'daterange',
      format: 'MM-dd',
      valueFormat: 'yyyy-MM-dd',
      clearable: true,
      params: ['insertStartTime', 'insertEndTime'],
    },
    {
      style: 'select',
      param: 'waybillPayStatusList',
      value: '',
      valueType: 'array',
      state: 'waybillPayStatus',
      label: '支付状态',
      placeholder: '请选择',
      clearable: true,
      filterable: false,
    },
    {
      style: 'autocomplete',
      param: 'payeeName',
      value: '',
      valueType: 'string',
      label: '收款人',
      placeholder: '请输入',
      noMatchText: '无匹配请输入',
      clearable: true,
      filterable: false,
      path: `${storeModuleName}/getPayee`,
    },
    {
      style: 'select',
      param: 'payType',
      value: '',
      valueType: 'string',
      state: 'payTypeList',
      label: '结算方式',
      placeholder: '请选择',
      clearable: true,
      filterable: false,
    },
    {
      style: 'autocomplete',
      param: 'projectName',
      value: '',
      valueType: 'string',
      label: '项目名称',
      placeholder: '请输入',
      noMatchText: '无匹配请输入',
      clearable: true,
      filterable: false,
      path: `${storeModuleName}/getProjectList`,
    },
    {
      style: 'date-picker',
      param: 'waybillCreateTime',
      value: [],
      valueType: 'date',
      label: '创建时间',
      placeholder: '请选择',
      type: 'daterange',
      format: 'MM-dd',
      valueFormat: 'yyyy-MM-dd',
      clearable: true,
      params: ['waybillCreateStartTime', 'waybillCreateEndTime'],
    },
    {
      style: 'date-picker',
      param: 'payTime',
      value: [],
      valueType: 'date',
      label: '支付时间',
      placeholder: '请选择',
      type: 'daterange',
      format: 'MM-dd',
      valueFormat: 'yyyy-MM-dd',
      clearable: true,
      params: ['payStartTime', 'payEndTime'],
    },
    {
      style: 'input',
      param: 'batchId',
      value: '',
      valueType: 'string',
      label: '支付批次',
      placeholder: '请输入',
      clearable: true,
    },
    {
      style: 'select',
      param: 'channelInfoIdList',
      value: [],
      valueType: 'array',
      state: 'channelInfos',
      label: '承运网货',
      placeholder: '请选择',
      clearable: true,
      filterable: false,
      multiple: true,
    },
    {
      style: 'date-picker',
      param: 'thirdWithdrawTime',
      value: [],
      valueType: 'date',
      label: '提现时间',
      placeholder: '请选择',
      type: 'daterange',
      format: 'MM-dd',
      valueFormat: 'yyyy-MM-dd',
      clearable: true,
      params: ['thirdWithdrawStartTime', 'thirdWithdrawEndTime'],
    },
    {
      style: 'select',
      param: 'settlementTypeList',
      value: [],
      valueType: 'array',
      state: 'settlementTypes',
      label: '申请类型',
      placeholder: '请选择',
      clearable: true,
      filterable: false,
      multiple: true,
    },
    {
      style: 'select',
      param: 'handlingAmtBack',
      value: '',
      valueType: 'string',
      state: 'whethers',
      label: '是否退款',
      placeholder: '请选择',
      clearable: true,
      filterable: false,
    },
    {
      style: 'date-picker',
      param: 'handlingAmtBackTime',
      value: [],
      valueType: 'date',
      label: '退款时间',
      placeholder: '请选择',
      type: 'daterange',
      format: 'MM-dd',
      valueFormat: 'yyyy-MM-dd',
      clearable: true,
      params: ['handlingAmtBackStartTime', 'handlingAmtBackEndTime'],
    },
    {
      style: 'input',
      param: 'creator',
      value: '',
      valueType: 'string',
      label: '运单创建人',
      placeholder: '请输入姓名/手机号',
      clearable: true,
    },
    {
      style: 'select',
      param: 'apiVersion',
      value: '',
      valueType: 'array',
      state: 'wojiaVersions',
      label: '我家运单筛选',
      placeholder: '请选择',
      clearable: true,
      filterable: false,
    },
  ],
  // 特殊筛选项目 带统计信息
  // 按钮筛选项
  isSpecialButton: [
    {
      title: '支付状态',
      name: 'payStatus',
      value: 'PAYING',
      selectList: [
        {
          value: 'ALL',
          label: '全部',
          isActive: false,
          count: 0,
        },
        {
          value: 'PAYING',
          label: '待支付',
          isActive: false,
          count: 0,
        },
        {
          value: 'LINE_PAYING',
          label: '支付中',
          isActive: false,
          count: 0,
        },
        {
          value: 'REFUSE',
          label: '已拒绝',
          isActive: false,
          count: 0,
        },
        {
          value: '0',
          label: '已支付',
          isActive: false,
          count: 0,
        },
        {
          value: '1',
          label: '已提现',
          isActive: false,
          count: 0,
        },
        {
          value: '2',
          label: '提现失败',
          isActive: false,
          count: 0,
        },
        {
          value: 'EXPIRED',
          label: '已过期',
          isActive: false,
          count: 0,
        },
      ],
    },
  ],
  isExport: {
    isShow: true,
    method: 'post',
    url: waybillSettlementExportUrl,
  }, // 导出
  // 页码
  postParams: {
    page: 1,
    size: 20,
  },
  // 列表data数据
  listData: {
    list: [],
    tableHeadList: [
      {
        label: '支付单信息',
        prop: 'payOrderInfo',
        width: 150,
        fixed: 'left',
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-payOrderInfo',
      },
      {
        label: '运单信息',
        prop: 'waybillInfo',
        width: 260,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-waybillInfo',
      },
      {
        label: '申请金额（元）',
        prop: 'applyAmount',
        width: 140,
        checked: 1,
        sortable: true,
        slotNameHeader: 'sub-header-applyAmount',
        slotName: 'sub-domain-applyAmount',
      },
      {
        label: '支付状态',
        prop: 'payStatus',
        width: 70,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-payStatus',
      },
      {
        label: '运力信息',
        prop: 'capacityInfo',
        width: 140,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-capacityInfo',
      },
      {
        label: '运单运费（元）',
        prop: 'waybillFreightDtoList',
        width: 250,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-waybillFreightDtoList',
      },
      {
        label: '系统时间',
        prop: 'systemTime',
        width: 240,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-systemTime',
      },
      {
        label: '风险提示',
        prop: 'riskTips',
        width: 220,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-riskTips',
      },
      {
        label: '备注',
        prop: 'payRemark',
        width: 160,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-payRemark',
      },
      {
        label: '银行流水回单',
        prop: 'electronicReceipt',
        width: 200,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-electronicReceipt',
      },
      {
        label: '批量支付批次',
        prop: 'batchId',
        width: 150,
        checked: 1,
        sortable: true,
        slotNameHeader: 'sub-header-batchId',
      },
      {
        label: '操作',
        width: 100,
        fixed: 'right',
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-operation',
      },
    ],
  },
  payStatus: [], // 支付状态统计
  companyList: [], // 企业列表
  channelInfos: [], // 网络货运平台列表
  companyInfo: '', // 当前选中的企业信息
  routeList: [], //线路列表
  payPwdExist: '', // 是否设置支付密码
  payPwdStatus: '', // 是否启用支付密码
  payTypeList, // 结算方式
  whethers, // 是或者否
  settlementTypes, // 结算单类型
  waybillPayStatus, // 运单支付状态
  wojiaVersions, //我家运单3.0  4.0
};

// getters
const getters = {};

// actions
const actions = {
  // 获取列表数据
  getList: async context => {
    const params = {};
    context.state.parameters.forEach(item => {
      if (item.style !== 'date-picker' && item.value) {
        if (item.multiple && item.value === 'string') {
          params[item.param] = item.value.toString();
        } else {
          params[item.param] = item.value;
        }
      }
      if (item.style === 'date-picker' && item.value.length > 0) {
        params[item.params[0]] = `${item.value[0]} 00:00:00`;
        params[item.params[1]] = `${item.value[1]} 23:59:59`;
      }
    });
    context.state.isSpecialButton.forEach(item => {
      if (item.value) params[item.name] = item.value;
    });
    if (params.orderName || context.state.orderId) {
      delete params['projectName'];
      delete context.state.postParams['projectId'];
    }
    // 获取统计信息
    context.dispatch('getStatistics');
    var payFreightListHabits = {};
    const obj = Object.assign({}, context.state.postParams);
    console.log('obj', obj);
    console.log('params', params);
    if (obj.businessId || params.businessId) {
      payFreightListHabits.businessId = obj.businessId ? obj.businessId : params.businessId;
    }
    if (obj.orderId) {
      payFreightListHabits.routeInfoId = obj.orderId;
    }
    localStorage.setItem('payFreightListHabits', JSON.stringify(payFreightListHabits));
    const { data } = await getWaybillSettlementList(
      Object.assign({}, params, context.state.postParams),
    );
    context.commit('updateState', {
      key: 'listData',
      value: Object.assign({}, context.state.listData, data),
    });
    context.dispatch('scheduledTask');
    return data.list;
  },
  // 获取状态统计数据
  getStatistics: async context => {
    const { data } = await getWaybillSettlementStatistics({
      businessId: context.state.parameters[0].value,
    });
    context.commit('updateState', {
      key: 'payStatus',
      value: data,
    });
    data.forEach(item => {
      const index = context.state.isSpecialButton[0].selectList.findIndex(selectItem => {
        return selectItem.value === (item.payStatus || item.thirdWithdrawStatus);
      });
      context.commit('updateButtonValueFromIndex', {
        index,
        value: item.count,
      });
    });
  },
  // 获取企业列表
  getCompanyList: async (context, payload) => {
    const data = JSON.parse(localStorage.getItem('group'));
    if (data && data.id) {
      // 只展示实名认证的企业列表
      context.commit('updateState', {
        key: 'payPwdExist',
        value: data.payPwdExist,
      });
      context.commit('updateState', {
        key: 'payPwdStatus',
        value: data.payPwdStatus,
      });
      const list = data.corporations.filter(item => item.realNameAudit === 1);
      if (list.length) {
        list.forEach(item => {
          item.label = item.principalPartName;
          item.value = item.businessId;
        });
      }
      context.commit('updateState', {
        key: 'companyList',
        value: list,
      });
    }
  },
  // 获取网货列表
  getChannelList: async context => {
    const { code, data } = await findChannelInfoByCorp({
      businessId: context.state.parameters[0].value,
    });
    if (code === 200) {
      const list = data.list.map(item => {
        return {
          label: item.name,
          value: item.id,
        };
      });
      context.commit('updateState', {
        key: 'channelInfos',
        value: list,
      });
    }
  },
  // 获取项目列表
  getProjectList: async (context, keyword) => {
    return new Promise(async (resolve, reject) => {
      const { code, data } = await getProjectListByBid({
        businessId: context.state.parameters[0].value,
        keyword,
      });
      if (code === 200) {
        data.list.forEach(item => {
          item.value = item.name;
        });
        resolve(data.list);
      } else {
        reject();
      }
    });
  },
  // 获取线路列表
  getRouteList: async (context, keyword) => {
    return new Promise(async (resolve, reject) => {
      const { code, data } = await getRouteListByBid({
        businessId: context.state.parameters[0].value,
        lineType: 'transfer',
        keyword,
      });
      if (code === 200) {
        data.list.forEach(item => {
          item.value = item.orderName;
        });
        context.commit('updateState', {
          key: 'routeList',
          value: data.list,
        });
        resolve(data.list);
      } else {
        reject();
      }
    });
  },
  // 获取收款人列表
  getPayee: async (context, payload) => {
    return new Promise(async (resolve, reject) => {
      const { code, data } = await getCollectionList({
        payeeName: payload,
      });
      if (code === 200) {
        data.records.forEach(item => {
          item.value = item.payeeName;
        });
        resolve(data.records);
      } else {
        reject();
      }
    });
  },
  // 定时任务
  scheduledTask: async context => {
    const { listData } = context.state;
    const { list } = listData;
    list.forEach(item => {
      // 结算过期倒计时预警提示
      item.isValid = true;
      if (item.payStatus === 'PAYING' && item.waybillCreateTime) {
        const waybillCreateTimeStamp = new Date(item.waybillCreateTime.replace(/-/g, '/'));
        const nowTimeStamp = new Date();
        const diffTimeStamp =
          item.settlementTime * 24 * 60 * 60 * 1000 - (nowTimeStamp - waybillCreateTimeStamp);
        if (diffTimeStamp > 0) {
          const countDownText = getHMSCountDownText(diffTimeStamp);
          item.isValid = true;
          item.riskTips = `请在运单创建时间后${item.settlementTime}天内完成支付，否则支付单系统会自动拒绝，当前还剩：${countDownText}`;
        } else {
          item.isValid = false;
          item.riskTips = `因未在运单创建时间后${item.settlementTime}天内完成支付，系统已自动驳回！`;
        }
      }
    });
    context.commit('updateState', {
      key: 'listData',
      value: Object.assign({}, listData, { list }),
    });
  },
};
// mutations
const mutations = {
  // 重置所有状态
  initFilter(state) {
    state.postParams = {
      page: 1,
      size: 20,
    };
    state.parameters.forEach(item => {
      if (item.isFixed) {
        return;
      }
      if (item.style !== 'date-picker' && item.value) {
        if (item.multiple && item.style !== 'input-multiple') {
          item.value = [];
        } else {
          item.value = '';
        }
      }
      if (item.style === 'date-picker') {
        item.value = [];
      }
    });
    state.isSpecialButton.forEach(item => {
      item.value = 'PAYING';
      item.selectList.forEach(select => {
        select.isActive = item.value.includes(select.value);
      });
    });
  },
  // 更新state数据
  updateState(state, { key, value }) {
    state[key] = value;
  },
  // 更新列表参数数据
  updatePostParams(state, payload) {
    state.postParams = Object.assign({}, state.postParams, payload);
  },
  // 根据index更新value
  async updateValueFromIndex(state, payload) {
    console.log('updateValueFromIndex', payload);
    const lastItem = state.parameters[state.parameters.length - 1];
    if (payload.index == 0) {
      const { code, data } = await findChannelInfoByCorp({
        businessId: payload.value,
      });
      let flag = false;
      if (code == 200) {
        const arr = data.list;
        arr.forEach(item => {
          if (
            item.supportRealtime == 1 &&
            item.supportHistory &&
            item.supportHistory == 1 &&
            item.id.indexOf('wojia') > -1
          ) {
            flag = true;
            arr.length = 0;
          }
        });
      }
      if (flag) {
        if (lastItem.param !== 'apiVersion') {
          const obj = {
            style: 'select',
            param: 'apiVersion',
            value: '',
            valueType: 'array',
            state: 'wojiaVersions',
            label: '我家运单筛选',
            placeholder: '请选择',
            clearable: true,
            filterable: false,
          };
          state.parameters.push(obj);
        }
      } else {
        if (lastItem.param == 'apiVersion') {
          state.parameters.splice(-1, 1);
        }
      }
    }
    state.parameters[payload.index].value = payload.value;
    switch (state.parameters[payload.index].param) {
      case 'businessId':
        if (payload.from !== 1) {
          localStorage.removeItem('payFreightListHabits');
          localStorage.setItem(
            'payFreightListHabits',
            JSON.stringify({
              businessId: payload.value,
            }),
          );
        }
        state.postParams.businessId = payload.value;
        state.companyInfo = state.companyList.find(item => item.businessId === payload.value);
        break;
      case 'projectName':
        state.postParams.projectId = payload.id;
        break;
      case 'orderName':
        state.postParams.orderId = payload.orderId;
        break;
      case 'payeeName':
        state.postParams.payeeMobile = payload.reserveMobileNo;
        break;
      default:
        break;
    }
  },
  // 根据index&value更新按钮状态
  updateSpecialStatusFromIndex(state, payload) {
    // 要修改的按钮组
    // const specialData = state.isSpecialButton[payload.index];
    // // 按钮组是否支持多选
    // if (payload.value === 'ALL') {
    //   specialData.value = '';
    //   specialData.selectList.forEach(item => {
    //     item.isActive = !payload.isActive;
    //   });
    // } else {
    //   // 选中的按钮
    //   const selects = [];
    //   specialData.selectList.forEach(item => {
    //     if (item.value === payload.value) item.isActive = !payload.isActive;
    //     if (item.value !== 'ALL' && item.isActive) selects.push(item.value);
    //   });
    //   // ‘全部’按钮
    //   const specialItemAll = specialData.selectList.find(item => item.value === 'ALL');
    //   specialItemAll.isActive = selects.length === specialData.selectList.length - 1;
    //   // 选中的值
    //   specialData.value = specialItemAll.isActive ? '' : selects;
    // }
    // 要修改的按钮组
    // const specialData = state.isSpecialButton[payload.index];
    // specialData.value = payload.value;
    // specialData.selectList.forEach(item => {
    //   item.isActive = item.value === payload.value;
    // });
    // 要修改的按钮组
    const specialData = state.isSpecialButton[payload.index];
    // 选中的按钮
    let selectValue = '';
    specialData.selectList.forEach(item => {
      item.isActive = false;
      if (item.value === payload.value) {
        item.isActive = true;
        if (payload.value !== 'ALL') selectValue = item.value;
      }
    });
    // 选中的值
    specialData.value = selectValue;
  },
  // 更新按钮统计数据
  updateButtonValueFromIndex(state, payload) {
    state.isSpecialButton[0].selectList[payload.index].count = payload.value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
